import { mapServerToProductBase } from "./map-server-to-product-base.js";
import { mapServerToSunglassesVariant } from "../../../../variant-mappers/mappers/server-to-client/variant-mappers/map-server-to-sunglasses-variant.js";
const mapServerToSunglassesProduct = (serverProduct, slug, locale, facetConfigList, flatFacetConfigList, priceSegmentChannelKey) => {
  if (serverProduct?.__typename !== "SunglassesProduct") {
    return {
      failure: "incorrect-typename",
      message: `Expected SunglassesProduct for slug "${slug}", but got ${serverProduct?.__typename}`
    };
  }
  const variants = mapServerToSunglassesVariant(serverProduct, slug, locale, priceSegmentChannelKey);
  if (!variants || variants.length === 0) {
    return {
      failure: "no-variants",
      message: `Cannot return Sunglasses product with slug: "${slug}" because it has no variants`
    };
  }
  const sunglasses = {
    ...mapServerToProductBase(serverProduct, variants, facetConfigList, flatFacetConfigList),
    productType: "Sunglasses",
    variants,
    isOfferedWithPrescriptions: !!serverProduct.productTypeDetails.isOfferedWithPrescriptions,
    isExclusiveBrand: serverProduct.productTypeDetails.isExclusiveBrand ?? void 0
  };
  return sunglasses;
};
export {
  mapServerToSunglassesProduct
};
//# sourceMappingURL=map-server-to-sunglasses-product.js.map
